module.exports = __webpack_public_path__ + "assets/img/jxsp-title.a34b7c95.png";